import { eAtlas, eManulSortLayerDrawOrder, Game, rnd2 } from "../../Game";
import { TIMER } from "../Gameplay";
import { TargetBase } from "./Targets/Target";
import { eTargetType, TargetType } from "./TargetType";



class ShardSprite {
    private _id: number;
    private _shardTargetOffset: pc.Vec2;
    private _entity: pc.Entity;

    private _stepX: number;
    private _stepY: number;

    private _velocityRatio: number;
    private _radialVelocity: pc.Vec3 = new pc.Vec3();

    private _pos: pc.Vec3;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(id: number, targetType: TargetType, batchGroupId: number, container: pc.GraphNode, pixelsPerUnit: number) {
        this._id = id;

        // Vypocitat krok po X a Y
        this._shardTargetOffset = targetType.shardOffsets[id];
        let dir = Math.atan2(this._shardTargetOffset.y, this._shardTargetOffset.x);

        this._stepX = Math.cos(dir);
        this._stepY = Math.sin(dir);

        // Vytvorit sprite
        let sprite = new pc.Sprite(Game.app.graphicsDevice, {
            atlas: Game.atlas,
            frameKeys: ["targets/shards/" + targetType.type + "_" + id],
            pixelsPerUnit: pixelsPerUnit,
            renderMode: pc.SPRITE_RENDERMODE_SIMPLE
        });

        // Entita se spritem
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.sprite, {
            drawOrder: eManulSortLayerDrawOrder.targetShards + id * 0.001,
            batchGroupId: batchGroupId,
            layers: [Game.manualSortLayer.id],
            sprite: sprite,
            type: pc.SPRITETYPE_SIMPLE
        });

        container.addChild(this._entity);

        // Pozice
        this._pos = new pc.Vec3(0, 0, 0);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(version: number): void {
        this._entity.sprite.sprite.frameKeys = ["targets/shards/" + version + "_" + this._id];

        this._pos.x = this._shardTargetOffset.x;
        this._pos.y = this._shardTargetOffset.y;

        this._entity.setLocalPosition(this._pos);
        this._entity.setEulerAngles(0, 0, 0);

        this._velocityRatio = rnd2.randomIn(0.3, 1);
        this._radialVelocity.x = rnd2.randomIn(-1, 1);
        this._radialVelocity.y = rnd2.randomIn(-1, 1);
        this._radialVelocity.z = rnd2.randomIn(2, 6);

        if (rnd2.randomBool())
            this._radialVelocity.z *= -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(velocity: number, gravity: number, opacity: number): void {
        velocity *= this._velocityRatio;

        this._pos.x += this._stepX * velocity;
        this._pos.y += (this._stepY * velocity) + gravity;

        this._entity.setLocalPosition(this._pos);
        this._entity.rotate(this._radialVelocity);
        this._entity.sprite.opacity = opacity;
    }
}



export class TargetShards {
    get targetType(): eTargetType { return this._targetType; }
    private _targetType: eTargetType;

    private _container: pc.GraphNode;
    private _shards: ShardSprite[];
    private _actTime: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(targetType: TargetType, batchGroupId: number) {
        let shardCnt = targetType.shardOffsets.length;
        let container = this._container = new pc.GraphNode();
        let targetPixW = (Game.getAtlas(eAtlas.def1).frames[targetType.frameKey] as pc.TextureAtlasFrame).rect.z;

        Game.app.root.addChild(this._container);

        this._targetType = targetType.type;
        this._shards = [];

        for (let shardId = 0; shardId < shardCnt; shardId++) {
            this._shards.push(new ShardSprite(shardId, targetType, batchGroupId, container, targetPixW));
        }

        this.reset();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._container.enabled = false;
        this._actTime = -1;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(target: TargetBase, version: number): void {
        this._shards.forEach((shard: ShardSprite): void => {
            shard.activate(version);
        });

        let scale = target.width * target.scale;

        this._container.setLocalScale(scale, scale, scale);
        this._container.setPosition(target.container.getPosition());
        this._container.enabled = true;

        this._actTime = TIMER.time;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (this._actTime < 0)
            return false;

        let progress = (TIMER.time - this._actTime) / 1000;

        if (progress >= 1) {
            this.reset();
            return false;
        }

        let velocity = (1.5 - 0 * pc.CubicIn(progress)) * TIMER.deltaS;
        let gravity = -5 * progress * TIMER.deltaS;
        let opacity = 1 - pc.SineIn(progress);

        this._shards.forEach((shard: ShardSprite): void => {
            shard.update(velocity, gravity, opacity);
        });

        // Opacity
        /*let batch = TargetManager.instance.shardBatch;

        if (batch) {
            let mat = batch.meshInstance.material as pc.StandardMaterial;

            mat.opacity = 1 - pc.CubicOut(progress);
            mat.update();
        }*/

        return true;
    }
}